import React, { useRef, useEffect } from 'react';
import { View, Text, Animated, StyleSheet, ScrollView, Dimensions } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { NavigationButtons } from './pages';

const { width, height } = Dimensions.get('window');

const HEART_COUNT = 20;

const FloatingHeart = ({ size, startX, delay, duration }) => {
  const translateY = useRef(new Animated.Value(height)).current;
  const opacity = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    const animate = () => {
      translateY.setValue(height);
      opacity.setValue(0);
      Animated.sequence([
        Animated.delay(delay),
        Animated.parallel([
          Animated.timing(translateY, {
            toValue: -80,
            duration,
            useNativeDriver: true,
          }),
          Animated.sequence([
            Animated.timing(opacity, {
              toValue: 0.85,
              duration: 400,
              useNativeDriver: true,
            }),
            Animated.delay(duration - 900),
            Animated.timing(opacity, {
              toValue: 0,
              duration: 500,
              useNativeDriver: true,
            }),
          ]),
        ]),
      ]).start(() => animate());
    };
    animate();
  }, []);

  return (
    <Animated.Text
      style={[
        styles.floatingHeart,
        {
          fontSize: size,
          left: startX,
          transform: [{ translateY }],
          opacity,
        },
      ]}
    >
      ❤️
    </Animated.Text>
  );
};

const Valentines2026 = ({ navigation }) => {
  const hearts = Array.from({ length: HEART_COUNT }, (_, i) => ({
    id: i,
    size: 14 + Math.floor((i * 7) % 18),
    startX: (i * (width / HEART_COUNT) + (i % 3) * 15) % (width - 30),
    delay: (i * 600) % 8000,
    duration: 5000 + ((i * 800) % 4000),
  }));

  return (
    <>
      <LinearGradient
        colors={['#FF4B6E', '#FF85A1', '#FFD6E0']}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
        style={styles.container}
      >
        <View style={styles.heartsLayer} pointerEvents="none">
          {hearts.map((h) => (
            <FloatingHeart
              key={h.id}
              size={h.size}
              startX={h.startX}
              delay={h.delay}
              duration={h.duration}
            />
          ))}
        </View>

        <ScrollView
          contentContainerStyle={styles.scrollContent}
          showsVerticalScrollIndicator={false}
        >
          <Text style={styles.title}>❤️ Happy Valentine's Day! ❤️</Text>
          <View style={styles.card}>
            <Text style={styles.message}>
              My lady Kimmy,{'\n\n'}
              Happy Valentine's Day 2026, our second valentines together. I am so grateful for every moment we've shared, through running around trying to catch lucy when we think its a good idea to let her off leash, singing off the top our lungs to alex warren because we're ORDINARY, to you meeting me in washington dc for a day so we spend it together and having such a fun day because of it. I thank you and appluad you for all you have done for us. I know living in two different states is not what your normal relationship consists of 
              but you have tried your best for US. These sacrifices may not be felt now but I promise you through these challenging times it will allow for us to build a better foundation, for our future, for our kids, for our family. We're racking up aura points to showcase to our kids when we're older. Me and Mom used to live in two different states and date haha, I look forward to all the aura points we can collect, ***spain one incoming***. 
              I am so pleased and proud to call you my girlfriend, my best friend, my soon to be PA but most importantly my soon to be Wife. Thank you for all you do for us, for me, for our future. I love you with all my heart and more and Happy Valentine's Day. 
              Seeing you laugh and smile is all I could ever ask for, te elijo no porque te necisito, sino porque contigo la vida se siente mas bonita. ❤️
            </Text>
          </View>
        </ScrollView>
      </LinearGradient>

      <NavigationButtons navigation={navigation} currentPage="Valentines 2026" />
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  heartsLayer: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 1,
  },
  floatingHeart: {
    position: 'absolute',
  },
  scrollContent: {
    zIndex: 2,
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 90,
    paddingBottom: 100,
    paddingHorizontal: 20,
  },
  title: {
    fontSize: 26,
    fontWeight: 'bold',
    color: '#FFFFFF',
    textAlign: 'center',
    marginBottom: 24,
    fontFamily: 'cursive',
    textShadowColor: 'rgba(180, 0, 50, 0.35)',
    textShadowOffset: { width: 1, height: 2 },
    textShadowRadius: 4,
  },
  card: {
    backgroundColor: 'rgba(255, 255, 255, 0.82)',
    borderRadius: 18,
    padding: 24,
    width: '100%',
    maxWidth: 480,
    shadowColor: '#C2185B',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 8,
    elevation: 6,
  },
  message: {
    fontSize: 16,
    color: '#5D1A2E',
    lineHeight: 26,
    textAlign: 'center',
    fontFamily: 'cursive',
  },
});

export default Valentines2026;
